import React, { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import classnames from 'classnames'
import { MuiThemeProvider } from 'material-ui/styles';
import { withStyles } from 'material-ui/styles';

import moment from 'moment';
import 'moment/locale/ru';

import Paper from 'material-ui/Paper';
import Tree from 'components/Tree';
import TopPanel from 'components/TopPanel';
import NoData from 'components/NoData';
import Loading from 'components/Loading';
import NodeInfo from 'components/NodeInfo';
import CollapseAll from 'components/CollapseAll';
import SearchDialog from 'components/SearchDialog';
import Message from 'components/Message';
import withAppStore from 'decorators/withAppStore';

import styles from 'styles/components/App';

export const ROOT_ID = 'App';

@withStyles(styles)
@withAppStore
@observer
export default class App extends Component {

  @computed
  get isTreeReady() {
    return this.appStore.isTreeReady;
  }

  @computed
  get hasData() {
    return this.appStore.treeStore.nodes.length > 0;
  }

  @computed
  get theme() {
    return this.appStore.theme;
  }

  @computed
  get showLoading() {
    return !this.isTreeReady;
  }

  @computed
  get showNoData() {
    return !!this.isTreeReady && !this.hasData && !this.appStore.hasApiError;
  }

  @computed
  get showTokenError() {
    const { isTreeReady, hasApiError, apiKey } = this.appStore;
    return isTreeReady && hasApiError && !apiKey;
  }

  get showOriginError() {
    const { isTreeReady, hasApiError, isOriginError } = this.appStore;
    return isTreeReady && hasApiError && isOriginError;
  }

  @computed
  get showTooManyRequestsError() {
    const { isTreeReady, hasApiError, isTooManyRequests } = this.appStore;
    return isTreeReady && hasApiError && isTooManyRequests;
  }

  @computed
  get showGeneralApiError() {
    const { isTreeReady, hasApiError, apiKey, isOriginError, isTooManyRequests } = this.appStore;
    return isTreeReady && hasApiError && apiKey && !isOriginError && !isTooManyRequests;
  }

  componentWillMount() {
    moment.locale('ru');
    document.getElementById('preloader').style.display = 'none';
  }
  
  @computed
  get showResults() {
    return !this.showTooManyRequestsError;
  }

  render() {
    const { classes } = this.props;

    return (
      <MuiThemeProvider theme={ this.theme }>
        <div className={ classnames(classes.root, classes.ready) } id={ ROOT_ID }>
          <TopPanel />
          <Paper elevation={0} square className={ classes.paper } >
          { this.showResults &&
            <Tree />
          }
            <Loading visible={ this.showLoading } />
            <NoData visible={ this.showNoData } />
            <NoData visible={ this.showApiError } text='Произошла ошибка загрузки данных' />
            <NoData visible={ this.showTokenError } text='Не указан параметр api-key' />
            <NoData visible={ this.showOriginError } text='Ключ API не соответствует домену, на котором размещен виджет' />
            <NoData visible={ this.showTooManyRequestsError } text={`Превышен лимит на количество запросов. Попробуйте ${moment().add(this.appStore.retryAfter, 'seconds').endOf().fromNow()}`} />
            <NodeInfo />
            <SearchDialog />
            <CollapseAll />
            <Message />
          </Paper>
        </div>
      </MuiThemeProvider>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/App.js